import { Component, OnInit, Input, Output, EventEmitter, SimpleChanges, ViewChild, ElementRef, OnDestroy } from '@angular/core';
import { Damage, DamageAnalysis, RoiAnalysis } from '../../model/damage.model';
import { NgbModalRef, NgbModal, ModalDismissReasons } from '@ng-bootstrap/ng-bootstrap';
import { FormControl, FormGroup } from '@angular/forms';
import 'parse';
import { DamageService } from '../../service/damage.service';
import { ReportService } from '../../service/report.service';
import { RoiService } from '../../service/roi.service';
import { flatten } from '@angular/compiler';
import { VehicleSeverityPipe } from '../../pipes/vehicle-severity.pipe';
import { Subscription } from 'rxjs';
import { TchekService } from '../../service/tchek.service';
import { TchekOldService } from '../../service/tchek-old.service';
import { TraceService } from '../../service/trace.service';
import { VehicleLocationPcPipe } from '../../pipes/vehicle-location-pc.pipe';
import { ParametersService } from '../../service/parameters.service';
import { I18n } from '@ngx-translate/i18n-polyfill';
import { ToastService } from '../../service/toast.service';
import { IAM } from 'aws-sdk';
import { SelectPossibleOption } from '../../model/search';
import { Tchekb } from '../../model/tchekb.model';
import { ImageCroppedEvent } from 'ngx-image-cropper';
import { TchekImage } from '../../model/image';

const parse: typeof Parse = require('parse');

@Component({
  selector: 'app-roi-edit-modal-v2',
  templateUrl: './roi-edit-modal-v2.component.html',
  styleUrls: ['./roi-edit-modal-v2.component.less']
})

export class RoiEditModalV2Component implements OnInit, OnDestroy {


  /// Modal Options

  closeResult: string;
  modalRef: NgbModalRef;
  subscription: Subscription;
  @Input() type: string;
  @Input() currentMode: string;
  @Input() currentImage: TchekImage;
  @Input() tchek: Tchekb;
  @Input() damageLoad: DamageAnalysis[];
  @Output() onSave = new EventEmitter();
  @Output() onCancel = new EventEmitter();
  @ViewChild('content') content: ElementRef;

  isAuto: boolean;
  data: any;
  index: any;
  deleteString: string;
  possibleValuesSelectDamage: SelectPossibleOption[];
  possibleValuesSelectLocation: SelectPossibleOption[];
  possibleValuesSelectSeverity: SelectPossibleOption[];
  possibleValuesSelectDelete: SelectPossibleOption[];
  possibleValuesSelectDeleteNotDamage: SelectPossibleOption[];
  possibleValuesSelectCost: SelectPossibleOption[];
  possibleValuesSelectDamageSize: SelectPossibleOption[];

  companyname: string

  isROIAuto: boolean;
  notDamage: boolean;
  text: boolean;
  showSubmit: boolean;
  errorEmpty: boolean;
  showAL: boolean;
  ALValues: SelectPossibleOption[];
  ALselected: string[]

  isOpen: boolean;
  other: FormControl;
  costValue: FormControl;

  newValueSelectDelete: string;
  newValueSelectDeleteNotDamage: string;
  newValueSelectDamage: string;
  newValueSelectLocation: string;
  newValueSelectSeverity: string;
  newValueSelectCost: string;
  newValueSelectDamageSize: string;

  isSuperAdmin = false;
  seenByInspector: boolean

  currentFiles: { src: string, roi: RoiAnalysis, isDeleted: boolean }[] = []
  files: File[] = [];
  onSelect(event) {
    this.files.push(...event.addedFiles);
  }

  onRemove(event) {
    this.files.splice(this.files.indexOf(event), 1);
  }

  constructor(private readonly i18n: I18n,
    private modalService: NgbModal,
    private _tchekService: TchekOldService,
    private readonly _traceService: TraceService,
    private readonly _damageService: DamageService,
    private readonly _toastService: ToastService,
    private readonly _reportService: ReportService,
    private readonly _damageLocationPipe: VehicleLocationPcPipe,
    private readonly _severitydamagePipe: VehicleSeverityPipe,
    readonly _roiService: RoiService,
    private readonly _parametersService: ParametersService
  ) {
    this.companyname = parse.User.current().get('companyPtr').get('identifier');

    this.isOpen = false;
    this.ALselected = []

    this.subscription = _damageService.openmodalObs.subscribe(data => {
      if (this.isOpen)
        return;
      if (data.type)
        this.type = data.type;
      this.data = data;
      this.openCanva()
    });


    this.possibleValuesSelectDamage = Object.entries(this._roiService.vehicleDamageTypes)
      .map<SelectPossibleOption>((t) => ({ key: t[0], value: t[1] }))
      .filter(opt => {
        return (opt.key !== 'added'
          && opt.key !== 'missing_part'
          && opt.key !== 'parking_sensor'
          && opt.key !== 'washer_nozzle'
        )
      })


    this.ALValues = [
      {
        key: 'invisible', value: this.i18n({
          id: 'notVisible',
          value: 'Non visible sur les images.',
          description: 'Non visible sur les images.',
          meaning: "editModal"
        })
      },
      {
        key: 'showByIA', value: this.i18n({
          id: 'seenByIA',
          value: "Vu par l'IA.",
          description: "Vu par l'IA.",
          meaning: "editModal"
        })
      },
      {
        key: 'isReal', value: this.i18n({
          id: 'realDamage',
          value: "Ceci est un vrai dommage.",
          description: "Ceci est un vrai dommage.",
          meaning: "editModal"
        })
      },
      {
        key: 'duplicate', value: this.i18n({
          id: 'duplicate',
          value: "Ceci est un doublon.",
          description: "Ceci est un doublon.",
          meaning: "editModal"
        })
      },
    ]


    this.possibleValuesSelectDamageSize = this._roiService.damageSizeRange

    this.possibleValuesSelectSeverity = this._roiService.severityOptionSelect

    this.possibleValuesSelectDelete = [
      {
        key: 'notDamage', value: this.i18n({
          id: 'notDamage',
          value: "Ce n\'est pas un dommage",
          description: "Ce n\'est pas un dommage",
          meaning: "editModal"
        })
      },
      {
        key: 'duplicate', value: this.i18n({
          id: 'duplicate',
          value: "C\'est un doublon",
          description: "C\'est un doublon",
          meaning: "editModal"
        })
      },
      {
        key: 'other', value: this.i18n({
          id: 'other',
          value: "Autre",
          description: "Autre",
          meaning: "editModal"
        })
      }
    ];

    this.possibleValuesSelectDeleteNotDamage = [
      {
        key: 'sensor', value: this.i18n({
          id: 'sensor',
          value: "C\'est un capteur",
          description: "C\'est un capteur",
          meaning: "editModal"
        })
      },
      {
        key: 'water', value: this.i18n({
          id: 'water',
          value: "C\'est une trace d'eau",
          description: "C\'est une trace d'eau",
          meaning: "editModal"
        })
      },
      {
        key: 'vehicleBody', value: this.i18n({
          id: 'vehicleBody',
          value: "Forme de la carrosserie",
          description: "Forme de la carrosserie",
          meaning: "editModal"
        })
      },
      {
        key: 'reflector', value: this.i18n({
          id: 'reflector',
          value: "C\'est un Reflet",
          description: "C\'est un Reflet",
          meaning: "editModal"
        })
      },
      {
        key: 'light', value: this.i18n({
          id: 'light',
          value: "C\'est une tâche de lumière",
          description: "C\'est une tâche de lumière",
          meaning: "editModal"
        })
      },
      {
        key: 'dirt', value: this.i18n({
          id: 'dirt',
          value: "C\'est une tâche / Saleté",
          description: "C\'est une tâche / Saleté",
          meaning: "editModal"
        })
      },
      {
        key: 'other', value: this.i18n({
          id: 'other',
          value: "Autre",
          description: "Autre",
          meaning: "editModal"
        })
      }
    ];

    this.possibleValuesSelectCost = [
      {
        key: 'manual', value: this.i18n({
          id: 'manual',
          value: "Manuel",
          description: "Manuel",
          meaning: "editModal"
        })
      },
      {
        key: 'sum', value: this.i18n({
          id: 'sum',
          value: "Forfaitaire",
          description: "Forfaitaire",
          meaning: "editModal"
        })
      },
      {
        key: 'webservice', value: this.i18n({
          id: 'webservice',
          value: "Webservice",
          description: "Webservice",
          meaning: "editModal"
        })
      },
      {
        key: 'ead', value: this.i18n({
          id: 'ead',
          value: "EAD",
          description: "EAD",
          meaning: "editModal"
        })
      }
    ];

    this.other = new FormControl('');
    this.costValue = new FormControl('');
    this.showSubmit = false;
    this.isROIAuto = false;
    this.notDamage = false;
    this.text = false;
    this.showAL = false;
    this.errorEmpty = false;
  }

  changeto(type: string) {
    this.type = type;
  }

  getCUrrentFileLength(): number {
    let length = 0
    if (this.currentFiles) length = this.currentFiles.filter(f => f.isDeleted === false).length
    return length
  }

  openCanva() {
    this.files = []
    this.currentFiles = []
    this.ALselected = []
    this.possibleValuesSelectLocation = flatten(Object.entries(this._roiService.parts)
      .map<SelectPossibleOption[]>(p => {
        return this._roiService
          .getAllLocationPossibleVariants(p[0], p[1])
          .map<SelectPossibleOption>(l => ({
            key: l,
            value: this._damageLocationPipe.transform(l)
          }));
      }));
    this.possibleValuesSelectLocation.sort(this.compare);

    this.other = new FormControl('');
    this.costValue = new FormControl('');
    this.isROIAuto = false;
    this.notDamage = false;
    this.text = false;
    this.errorEmpty = false;
    this.showAL = false;
    this.isSuperAdmin = this._parametersService.isSuperAdmin


    if (this.type === 'edit') {


      this.index = this.damageLoad.findIndex(d => { return d.id === this.data.id });
      if (this.index === -1)
        return;

      if (this.damageLoad[this.index].listRoi) {
        this.damageLoad[this.index].listRoi.forEach(roi => {
          if (roi.imagePtr && roi.isDeleted !== true && roi.imagePtr.isDeleted !== true && roi.imagePtr.file.url()) {
            if ((this.currentMode === 'image' && roi.id !== this.damageLoad[this.index].roiPtr.id) || this.currentMode === 'video')
              this.currentFiles.push({ roi: roi, src: roi.imagePtr.file.url(), isDeleted: false })
          }
        })
      }

      if (this.damageLoad[this.index].seenByInspector !== undefined)
        this.seenByInspector = this.damageLoad[this.index].seenByInspector

      if (this.damageLoad[this.index].isAuto !== true)
        this.ALValues = [
          { key: 'invisible', value: 'Non visible sur les images.' },
          { key: 'showByIA', value: "Vu par l'IA." },
        ]
      else if (this.damageLoad[this.index].isDeleted)
        this.ALValues = [
          { key: 'isReal', value: "Ceci est un vrai dommage." },
          { key: 'duplicate', value: "Ceci est un doublon." },
        ]
      else
        this.ALValues = [
          { key: 'duplicate', value: "Ceci est un doublon." },
        ]

      if (this.damageLoad[this.index].cost > 0) {
        this.costValue = new FormControl(this.damageLoad[this.index].cost);
      }
      if (this.damageLoad[this.index].costType && this.damageLoad[this.index].costType !== undefined) {
        this.newValueSelectCost = this.damageLoad[this.index].costType;
      }
      else if (this._parametersService.getAll().report && this._parametersService.getAll().report.selectorCost) {
        this.newValueSelectCost = this._parametersService.getAll().report.selectorCost;
      }
      else {
        this.newValueSelectCost = 'sum'
      }
      if (this.damageLoad[this.index].id) {
        this.isAuto = this.damageLoad[this.index].roiPtr.isAuto;
        this.open(this.content)
        this.newValueSelectDelete = undefined;
        this.newValueSelectDeleteNotDamage = undefined;
        if (this.damageLoad[this.index].type) {
          this.newValueSelectDamage = this.locationToOption(this.damageLoad[this.index].type).key;
        } else {
          this.newValueSelectDamage = 'bump'
        }
        if (this.damageLoad[this.index].location) {
          this.newValueSelectLocation = this.locationToOption(this.damageLoad[this.index].location).key;
        } else {
          this.newValueSelectLocation = this.possibleValuesSelectLocation[0].key;
        }

        if (this.damageLoad[this.index].sizeRange) {
          this.newValueSelectDamageSize = this.damageLoad[this.index].sizeRange;
        } else if (this.damageLoad[this.index].radiusWorld) {
          this.newValueSelectDamageSize = this.getSizeByRadius(this.damageLoad[this.index].radiusWorld);
        } else {
          this.newValueSelectDamageSize = this.possibleValuesSelectDamageSize[0].key;
        }

        if (this.damageLoad[this.index].severity) {
          this.newValueSelectSeverity = this.severityToOption(this.damageLoad[this.index].severity).key;
        } else {
          this.newValueSelectSeverity = 'SEV0'
        }
      }
      if (this.damageLoad[this.index].activeLearningStatus && this.damageLoad[this.index].activeLearningStatus.length > 0)
        this.ALselected = this.damageLoad[this.index].activeLearningStatus
      if (this.ALselected.length > 0)
        this.showAL = true
      else
        this.showAL = false
    }
    else if (this.type === 'create') {
      let side;

      if (this.currentMode === 'video')
        if (this.tchek.way)
          if (this.data.cameraNumber > 6 && !(this.data.cameraNumber == 13 || this.data.cameraNumber == 14))
            side = ['G']
          else
            side = ['D', 'DF']
        else
          if (this.data.cameraNumber > 6 && !(this.data.cameraNumber == 13 || this.data.cameraNumber == 14))
            side = ['D', 'DF']
          else
            side = ['G']
      else
        side = []

      this.possibleValuesSelectLocation = this.possibleValuesSelectLocation.filter((location) => {
        let result = true
        side.forEach(end => {
          if (location.key.endsWith(end))
            result = false
        });
        return result
      })
      this.open(this.content);
      if (this._parametersService.getAll().report && this._parametersService.getAll().report.selectorCost) {
        this.newValueSelectCost = this._parametersService.getAll().report.selectorCost;
      }
      else
        this.newValueSelectCost = 'manual';
      this.newValueSelectSeverity = 'SEV0';
      this.newValueSelectDamage = 'bump';
      this.newValueSelectDamageSize = this.possibleValuesSelectDamageSize[0].key;
      this.newValueSelectLocation = this.possibleValuesSelectLocation[0].key;
    }
    else if (this.type === 'delete') {
      this.showSubmit = false;
      this.index = this.damageLoad.findIndex(d => { return d.id === this.data.id });
      if (this.index === -1)
        return;
      if (this.damageLoad[this.index].id) {
        this.isAuto = this.damageLoad[this.index].roiPtr.isAuto;
        this.open(this.content)
        this.newValueSelectDelete = undefined
        this.newValueSelectDeleteNotDamage = undefined
      }
    }
    this.handlerChangeCost(true)
  }

  ngOnInit(): void {
  }

  handlerChangeCost(init = false) {
    console.log('handler cost condition : ', parseInt(this.costValue.value, 10) >= 0, init === false || (parseInt(this.costValue.value, 10) >= 0) === false);
    if (this.newValueSelectCost !== 'manual') {
      this.costValue.disable();
      if (init === false || (parseInt(this.costValue.value, 10) >= 0) === false)
        this._damageService.predictRepairCost(this.tchek.id,
          this.newValueSelectDamage,
          this.newValueSelectCost,
          this.newValueSelectSeverity,
          this.newValueSelectLocation,
          this.costValue.value).then(res => {
            console.log('handler cost res', res);
            // if (res.error !== true)
            this.costValue.setValue(res.cost);
          })

    } else {
      this.costValue.enable();
    }
  }


  ngOnChanges(changes: SimpleChanges) {
  }

  ngOnDestroy() {
    // prevent memory leak when component destroyed
    this.subscription.unsubscribe();
  }

  getSizeByRadius(radius: number): string {
    radius /= 10;
    for (let index = 0; index < this._roiService.damageSizeRange.length; index++) {
      const sev = this._roiService.damageSizeRange[index];
      if (sev.range.length === 2) {
        if (radius >= sev.range[0] && radius < sev.range[1]) {
          return sev.key
        }
      } else {
        if (radius >= sev.range[0])
          return sev.key
      }
    }
  }

  onChange(event, select?: string) {
    //console.log("change" , event);
    if (this.costValue.value > 0)
      this.errorEmpty = false;
    if (this.newValueSelectDelete === undefined)
      this.showSubmit = false;
    else
      this.showSubmit = true;

    if (select === 'type' && event.key === "other") {
      this.notDamage = false;
      this.text = true;
    }
    else if (select === 'type' && event.key === "notDamage" && this.notDamage === false) {
      this.notDamage = true;
      this.text = false;
    }
    else if (select === 'option' && event.key === 'other' && this.notDamage === true) {
      this.text = true;
    }
    else if (select === 'option' && this.notDamage === true) {
      this.text = false;
    }
    else {
      this.notDamage = false;
      this.text = false;
    }
  }


  saveModal() {
    this.modalRef.close('Save click')
  }



  convertDataURIToBinaryFetch(dataURI) {
    return fetch(dataURI)
      .then((res) => res.blob());
  }

  openImport() {
    document.getElementById('set_file').click();
  }

  async open(content: any) {
    this.isOpen = true;
    this.modalRef = await this.modalService.open(content, { backdropClass: 'backdropClassModal' });

    this.modalRef.result.then(async (result) => {
      this.isOpen = false;
      this.closeResult = `Closed with: ${result}`;
      if (this.type === 'edit') {

        /// OLD TRACE ACTION
        let action = `edit damage : \
        { old : \
        { severity : ${this.damageLoad[this.index].severity}, \
        location : ${this.damageLoad[this.index].location}, \
        sizeRange : ${this.damageLoad[this.index].sizeRange}, \
        type : ${this.damageLoad[this.index].type},\
        costType : ${this.damageLoad[this.index].costType},\
      cost : ${this.damageLoad[this.index].cost}}, \
        new : \
        { severity : ${this.newValueSelectSeverity}, \
        location : ${this.newValueSelectLocation}, \
        sizeRange : ${this.newValueSelectDamageSize}, \
        type : ${this.newValueSelectDamage},'
        costType : ${this.newValueSelectCost},\
        cost : ${this.costValue.value}}}`

        /// NEW TRACE DATA
        let data = {
          type: 'edit damage',
          data: {
            old:
            {
              severity: this.damageLoad[this.index].severity,
              location: this.damageLoad[this.index].location,
              sizeRange: this.damageLoad[this.index].sizeRange,
              type: this.damageLoad[this.index].type,
              costType: this.damageLoad[this.index].costType,
              cost: this.damageLoad[this.index].cost,
            },
            new:
            {
              severity: this.newValueSelectSeverity,
              location: this.newValueSelectLocation,
              sizeRange: this.newValueSelectDamageSize,
              type: this.newValueSelectDamage,
              costType: this.newValueSelectCost,
              cost: this.costValue.value
            }
          },
          tool: 'modalv2',
          timetoUpdate: undefined
        }

        this._traceService.saveTrace(
          this.damageLoad[this.index].tchekPtr.id,
          action, this.damageLoad[this.index].id, data)

        this.damageLoad[this.index].seenByInspector = this.seenByInspector;
        this.damageLoad[this.index].costType = this.newValueSelectCost;
        this.damageLoad[this.index].cost = Number(this.costValue.value);

        this.damageLoad[this.index].severity = this.newValueSelectSeverity;
        this.damageLoad[this.index].sizeRange = this.newValueSelectDamageSize
        this.damageLoad[this.index].location = this.newValueSelectLocation
        this.damageLoad[this.index].type = this.newValueSelectDamage;
        if (this.showAL && this.ALselected.length > 0)
          this.damageLoad[this.index].activeLearningStatus = this.ALselected;
        else
          this.damageLoad[this.index].activeLearningStatus = []


        if (this.currentFiles && this.currentFiles.length > 0) {
          let tmp = []
          this.currentFiles.filter(f => f.isDeleted === true).forEach(f => {
            tmp = this.damageLoad[this.index].listRoi.filter(roi => roi.id !== f.roi.id)
            this._roiService.deleteRoi(f.roi.getParseInstance())
          })
          if (tmp.findIndex(r => { return r.id === this.damageLoad[this.index].roiPtr.id }) === -1) {
            // change best roi if best roi deleted
            if (tmp.length > 0)
              this.damageLoad[this.index].roiPtr = tmp[0]
          }
          if (this.isSuperAdmin !== true)
            this.damageLoad[this.index].listRoi = tmp
        }

        this.saveData();
      } else if (this.type === 'create') {
        let modalData = {
          images: this.files,
          selectedCostType: this.newValueSelectCost,
          selectedCost: Number(this.costValue.value),
          selectedLocation: this.newValueSelectLocation,
          selectedType: this.newValueSelectDamage,
          selectedSizeRange: this.newValueSelectDamageSize,
          selectedSeverity: this.newValueSelectSeverity,
          isROIAuto: this.isROIAuto,
          imagePtr: this.currentImage
        }
        this._damageService.reloadDamages = true
        this.data.modalData = modalData;
        this._damageService.saveRoi(this.data);
        this.onSave.emit({ type: 'create', damage: this.data });
      } else if (this.type === 'delete') {

        /// OLD TRACE ACTION
        if (this.text && this.notDamage) {
          this.deleteString = `Delete damage because of ${this.newValueSelectDelete} \
        ${this.newValueSelectDeleteNotDamage} \
        ${this.other.value}`;
        } else if (this.text && !this.notDamage) {
          this.deleteString = `Delete damage because of ${this.newValueSelectDelete} \
        ${this.other.value}`;
        } else if (!this.text && this.notDamage) {
          this.deleteString = `Delete damage because of ${this.newValueSelectDelete} \
        ${this.newValueSelectDeleteNotDamage}`;
        } else {
          this.deleteString = `Delete damage because of ${this.newValueSelectDelete};`
        }



        if (this.newValueSelectDelete === null || this.newValueSelectDelete === undefined ) this.newValueSelectDelete = "notDamage"
        /// NEW TRACE DATA
        let data = {
          type: 'delete damage',
          data: {
            key: this.newValueSelectDeleteNotDamage ? this.newValueSelectDeleteNotDamage : this.newValueSelectDelete,
            value: this.newValueSelectDeleteNotDamage ?
              this.possibleValuesSelectDeleteNotDamage[this.possibleValuesSelectDeleteNotDamage.findIndex(d => { return d.key === this.newValueSelectDeleteNotDamage })].value
              : this.possibleValuesSelectDelete[this.possibleValuesSelectDelete.findIndex(d => { return d.key === this.newValueSelectDelete })].value,
          },
          tool: 'modalv2',
          timetoUpdate: undefined
        }
        if (this.newValueSelectDelete === 'other')
          data.data['other'] = this.other.value
        console.log(data);

        this._traceService.saveTrace(
          this.damageLoad[this.index].tchekPtr.id,
          this.deleteString, this.damageLoad[this.index].id, data);
        this.onSave.emit({ type: 'delete', damage: this.damageLoad[this.index] });
        this._damageService.reloadDamages = true
      }
    }, (reason) => {
      this.isOpen = false;
      if (this.type === 'create')
        this._damageService.cancelRoi(this.data);
      this.onCancel.emit();
      this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
    });
  }

  handleDamageInspectorCheckbox() {
    this.seenByInspector = !this.seenByInspector
  }

  saveData() {
    this._toastService.toastOpen(true);
    console.log(this.damageLoad[this.index])
    this.damageLoad[this.index].toSync = true;
    this._damageService.save(this.damageLoad[this.index])
      .then((savedDamage: Damage) => {
        if (savedDamage) {
          if (this.files && this.files.length > 0) {
            this._damageService.saveRoiFile(this.damageLoad[this.index], this.files).then(() => {
              this._toastService.toastOpen(false);
            })
          } else this._toastService.toastOpen(false)
          let damage = new DamageAnalysis(savedDamage, this.damageLoad[this.index].listRoi)
          this.onSave.emit({ type: 'edit', damage: damage });
        }
      });
  }

  private getDismissReason(reason: any): string {
    if (reason === ModalDismissReasons.ESC) {
      return 'by pressing ESC';
    } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
      return 'by clicking on a backdrop';
    } else {
      return `with: ${reason}`;
    }
  }

  locationToOption(locationKey: string): SelectPossibleOption {
    //console.log("location key", locationKey, "locaiton pipe", this._damageLocationPipe.transform(locationKey));
    locationKey = this.definelocationkey(locationKey);
    return new SelectPossibleOption(
      locationKey,
      this._damageLocationPipe.transform(locationKey)
    );
  }

  clickALselector(key: string) {
    if (this.ALselected.includes(key)) {
      const index = this.ALselected.indexOf(key);
      if (index > -1) {
        this.ALselected.splice(index, 1);
      }
    } else {
      if (!this.ALselected)
        this.ALselected = []
      this.ALselected.push(key)
    }
    console.log(key, this.ALselected);
  }

  severityToOption(severityKey: string): SelectPossibleOption {
    //console.log("location key", locationKey, "locaiton pipe", this._damageLocationPipe.transform(locationKey));
    return new SelectPossibleOption(
      severityKey,
      this._severitydamagePipe.transform(severityKey)
    );
  }

  definelocationkey(locationKey: string): string {
    switch (locationKey) {
      case 'TOIAVG':
      case 'TOIAVD':
      case 'TOIARG':
      case 'TOIARD':
        return 'TOI'
      case 'CFRAVG':
      case 'CFRAVD':
      case 'CFRARG':
      case 'CFRARD':
        return 'CFR'
      case 'CPTAVG':
      case 'CPTAVD':
      case 'CPTARG':
      case 'CPTARD':
        return 'CPT'
      case 'CLRAVG':
      case 'CLRAVD':
      case 'CLRARG':
      case 'CLRARD':
        return 'CLR'
      case 'PRCARG':
      case 'PRCARD':
        return 'PRCAR'
      case 'PRCAVG':
      case 'PRCAVD':
        return 'PRCAV'
      default:
        return locationKey
    }
  }

  compare(a, b) {
    if (a.value < b.value) {
      return -1;
    }
    if (a.value > b.value) {
      return 1;
    }
    return 0;
  }
}


// WEBPACK FOOTER //
// ./src/app/element/roi-edit-modal-v2/roi-edit-modal-v2.component.ts